import moment from "moment";
import { humanDateFormat } from "../../config/constants";

export const statusNovedad = {
  RESUELTA: "Resuelta",
  PENDIENTE: "Pendiente",
  GESTION: "En Gestion",
  VENCIDA: " (Vencida)",
};

export const novedadUtil = (novedad) => {
  const novedadObj = {
    ...novedad,

    startDate: () => {
      const dates = novedad.tareas ? novedad.tareas.map((tarea) => moment(tarea.dueDate).add(1, "hour")) : null;
      if (dates && dates.length > 0) {
        const minDate = new Date(Math.min.apply(null, dates));
        return minDate;
      }
      return null;
    },

    startDateTask: () => {
      const filteredTaks = novedad.tareas && novedad.tareas.filter((tarea) => tarea.class.id === 1);
      const dates = filteredTaks && filteredTaks.map((tarea) => moment(tarea.dueDate).add(1, "hour"));
      if (dates && dates.length > 0) {
        const minDate = new Date(Math.min.apply(null, dates));
        return minDate;
      }
      return null;
    },

    endDate: () => {
      const dates = novedad.tareas ? novedad.tareas.map((tarea) => tarea.class.id === 1 && moment(tarea.dueDate).add(1, "hour")) : null;
      if (dates && dates.length > 0) {
        const maxDate = new Date(Math.max.apply(null, dates));
        return maxDate;
      }
      return null;
    },

    resolveDate: () => {
      if (novedad.tareas) {
        const tareas = [...novedad.tareas.filter((tarea) => tarea.class.id === 1)];
        const orderedTasks = tareas.sort((a, b) => moment(a.dueDate) - moment(b.dueDate));
        const lastTaskOrdered = orderedTasks[tareas.length - 1];
        if (lastTaskOrdered && lastTaskOrdered.completeDate) {
          return lastTaskOrdered.completeDate;
        }
      }
      return null;
    },

    nextDueDate: () => {
      const dates = novedad.tareas ? novedad.tareas.filter((tarea) => !tarea.completeDate).map((tarea) => moment(tarea.dueDate)) : null;
      if (dates && dates.length > 0) {
        const minDate = new Date(Math.min.apply(null, dates));
        return minDate;
      }
      return null;
    },

    isVencida: () => {
      if (novedad.tareas && novedad.tareas.length > 0) {
        // const sortTasks = novedad.tareas.sort((taska, taskb) => new Date(taskb.dueData) - new Date(taska.dueDate));
        // const firstTaskUnresolved = sortTasks.find((task) => task.completeDate === null);
        // const checkTask = firstTaskUnresolved || sortTasks[sortTasks.length - 1];
        // if (checkTask) {
        //   const checkDate = firstTaskUnresolved ? moment().format(queryDateFormat) : checkTask.completeDate;
        //   return moment(checkTask.dueDate).diff(checkDate, "days") < 0;
        // }
        const vencidas = novedad.tareas.filter((task) => {
          return task.status === "vencido";
        });
        if (vencidas && vencidas.length > 0) {
          return true;
        }
      }
      return false;
    },
  };

  return {
    ...novedadObj,

    statusStr: (onlyStatus = false) => {
      let total = 0;
      let pendientes = 0;
      let resueltas = 0;
      const vencida = novedadObj.isVencida() && !onlyStatus ? statusNovedad.VENCIDA : "";

      if (novedadObj.tareas) {
        total = novedadObj.tareas.length;
        novedadObj.tareas.forEach((task) => {
          if (task.completeDate === null) {
            pendientes += 1;
          } else {
            resueltas += 1;
          }
        });
      }

      if (total !== 0 && total - resueltas === 0) {
        return statusNovedad.RESUELTA + vencida;
      }
      return pendientes === total ? statusNovedad.PENDIENTE : statusNovedad.GESTION + vencida;
    },

    statusColorClass: (statusString) => {
      if (statusString.includes(statusNovedad.VENCIDA)) {
        return "text-danger";
      }
      if (statusString.includes(statusNovedad.RESUELTA)) {
        return "text-success";
      }
      if (statusString.includes(statusNovedad.PENDIENTE)) {
        return "text-warning";
      }
      if (statusString.includes(statusNovedad.GESTION)) {
        return "text-info";
      }
      return "";
    },

    startDateFormatted: () => (novedadObj.startDateTask() ? moment(novedadObj.startDateTask()).format(humanDateFormat) : "-"),

    endDateFormatted: () => (novedadObj.endDate() ? moment(novedadObj.endDate()).format(humanDateFormat) : "-"),

    resolveDateFormatted: () => (novedadObj.resolveDate() ? moment(novedadObj.resolveDate()).format(humanDateFormat) : "-"),
  };
};
